import styled from 'styled-components'

import { FlexRowDiv, H1, P, A } from 'components/generic/HomePageComponents.js'

import {
  mainHeader,
  para1,
  para2,
  para3,
  secondHeader,
  secondPara,
  articles,
  babysittingLinks,
  babysittingServices,
} from 'lib/BBJData'

const CCAButton = styled(A)`
  background-color: ${(props) => props.theme.colors.inverseColor};
  transition: background-color 0.5s ease;
  width: 400px;
  padding: 10px 48px;
  font-weight: bold;
  white-space: normal;
  font-size: ${(props) => props.theme.buttonTextSize};
  margin-top: 35px;
  border: 2px #fff solid;
  text-decoration: none;
  color: ${(props) => props.theme.buttonColor};
  border-radius: 5px;
  text-align: center;
  :hover {
    cursor: pointer;
    background-color: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.inverseColor};
    border-color: ${(props) => props.theme.colors.inverseColor};
  }
`

const StrippedDiv = styled(FlexRowDiv)`
  :nth-of-type(even) {
    background-color: rgb(249, 249, 249);
  }
`
const TableP = (props) => <P {...props} />

const MyA = styled(TableP)`
  text-decoration: none;
  color: ${(props) => props.theme.colors.inverseColor};
  :hover {
    text-decoration: underline;
    cursor: pointer;
  }
`
const MyP = (props) => <P maxWidth='100%' {...props} />
const RowP = (props) => <P {...props} />
const MainRow = (props) => (
  <FlexRowDiv pt='100px' {...props} pb='100px'>
    <FlexRowDiv
      flexDirection={['column', 'column', 'row']}
      justifyContent='space-around'
      maxWidth='1259px'
      width='100%'
      ml={['10px', '20px', '20px']}
      mr={['10px', '20px', '20px']}
    >
      {props.children}
    </FlexRowDiv>
  </FlexRowDiv>
)

const ColumnOne = (props) => (
  <FlexRowDiv
    {...props}
    flexDirection='column'
    width={['90%', '100%', '100%']}
    pr='30px'
    ml='10px'
    mr='10px'
  >
    <H1 mb='15px'>{mainHeader}</H1>
    <MyP>{para1}</MyP>
    <MyP>{para2}</MyP>
    <MyP>{para3}</MyP>
    <H1 mb='15px'>{secondHeader}</H1>
    <MyP>{secondPara}</MyP>
    {props.children}
  </FlexRowDiv>
)

const HeaderRow = (props) => (
  <FlexRowDiv
    justifyContent='flex-start'
    borderTop='1px solid'
    borderBottom='1px solid'
    borderLeft='1px solid'
    borderRight='1px solid'
    borderColor='rgb(221, 221, 221)'
    paddingTop='0px'
  >
    <P
      fontWeight='700'
      width={['220px', '180px', '270px']}
      pl='10px'
      border='1px solid'
      borderColor='rgb(221, 221, 221)'
      height='100%'
      verticalAlign='middle'
      marginTop='0px'
      pt='15px'
    >
      Article
    </P>
    <P
      fontWeight='700'
      flexBasis={['400px', '400px', '500px']}
      maxWidth='1000px'
      pl='10px'
      borderTop='1px solid'
      borderBottom='1px solid'
      mt='0px'
      pt='15px'
      borderColor='rgb(221, 221, 221)'
      height='100%'
    >
      Description
    </P>
  </FlexRowDiv>
)
const Table = (props) => (
  <FlexRowDiv flexDirection='column' {...props}>
    <HeaderRow />

    {articlesRows}
  </FlexRowDiv>
)

const articlesRows =
  articles &&
  articles.length > 0 &&
  articles.map(({ title, link, description }, index) => (
    <StrippedDiv
      justifyContent='flex-start'
      borderTop='1px solid'
      borderBottom='1px solid'
      borderLeft='1px solid'
      borderRight='1px solid'
      borderColor='rgb(221, 221, 221)'
      key={index}
    >
      <MyA
        href={link}
        width={['220px', '180px', '270px']}
        pt='20px'
        mt='0px'
        pl='10px'
        borderRight='1px solid'
        borderColor='rgb(221,221,221)'
        height='100%'
      >
        {title}
      </MyA>
      <RowP flexBasis={['400px', '400px', '500px']} maxWidth='600px' pl='10px'>
        {description}
      </RowP>
    </StrippedDiv>
  ))

const ColumnTwo = (props) => (
  <FlexRowDiv
    flexDirection='column'
    justifyContent='center'
    alignItems='center'
    width={['90%', '100%', '50%']}
    ml='10px'
    mr='10px'
  >
    <CCAButton href='https://sitter.com/jobs' bg='blue'>
      Babysitter Jobs on Sitter.com
    </CCAButton>
    <FlexRowDiv>
      <MyA href='sitter.com'>Sitter.com</MyA>
      <P>Are you looking for a babysitter?</P>
      <MyA href='sitter.com'>Find one today!</MyA>
    </FlexRowDiv>
    <FlexRowDiv
      flexDirection='column'
      bg='#f5f5f5'
      pt='20px'
      mt='20px'
      width={['100%', '100%', '100%']}
      borderRadius='10px'
      border='1px rgb(234, 217, 217) solid'
    >
      <P pl='20px' fontSize='24px' fontWeight='700'>
        Babysitter Jobs
      </P>
      <MakeRows links={babysittingLinks} />
      <P pl='20px' fontSize='24px' fontWeight='700'>
        Babysitter Services
      </P>
      <MakeRows links={babysittingServices} />
    </FlexRowDiv>
  </FlexRowDiv>
)

const MakeRows = ({ links }) =>
  links &&
  links.length > 0 &&
  links.map(({ title, link }, index) => (
    <MyA key={index} href={link} title={title} pl='20px'>
      {title}
    </MyA>
  ))

const BabySitterJobs = () => (
  <MainRow>
    <ColumnOne>
      <Table />
    </ColumnOne>
    <ColumnTwo />
  </MainRow>
)
export default BabySitterJobs
